import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanyDetailsModel } from '../../models/company-details-model';
import { IHeaderTitle } from '../../../shared/models/header-title';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from '../../services/company.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-company-audit-template',
  templateUrl: './company-audit-template.component.html',
  styleUrls: ['./company-audit-template.component.css']
})
export class CompanyAuditTemplateComponent implements OnInit {
    companyDetailsModel: CompanyDetailsModel;
    errors: string[];
    headerTitle: IHeaderTitle;
    submitAttempt = false;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    isAddMode: boolean = false;
    companyId: string;

    constructor(
        private companyService: CompanyService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.companyId = this.activatedRoute.snapshot.params['id'];
        this.load();
    }

    load(): void {
        this.companyService.get(this.companyId).subscribe(companyInfo => {
            this.companyDetailsModel = companyInfo;
            this.headerTitle = {
                title: companyInfo.legalName,
                breadcrumbs: [{ title: 'Companies', url: ['/company'] }]
            };
        });


    }

    toggleAddMode(): void {
        this.isAddMode = !this.isAddMode;
    }

    auditTemplateAdded($event: string): void {
        this.load();
        this.isAddMode = false;

    }
    

}
